import React from "react";
import styled from "styled-components";
// import { Link } from "../../styling/card";
import { FacebookIcon, InstagramIcon } from "../../icons";

const FooterContainer = styled.div`
  /* flex-shrink: 0;
  justify-content: center;
  display: flex;
  white-space: break-spaces; */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px 0 8px 0;
  font-size: 12px;
  font-family: ${(props) => props.theme.font.montserrat};
  color: ${(props) => props.theme.color.pink};
`;

const IconContainer = styled.div`
  display: flex;
  a {
    margin: 24px;
  }
  svg {
    width: 60px;
    height: 100%;
  }
`;

export const Footer: React.FC = () => {
  const DATE = new Date();
  const YEAR = DATE.getFullYear();

  return (
    <FooterContainer>
      <IconContainer>
        <a
          href="https://www.facebook.com/BakingSocietyUoB/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FacebookIcon />
        </a>
        <a
          href="https://www.instagram.com/bakingsocietyuob/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramIcon />
        </a>
      </IconContainer>
      <div>
        © BAKESOC {YEAR}
      </div>
    </FooterContainer>
  );
};
